export enum NotificationMessageType {
    Push = 1,
    Sms = 2,
    Telegram = 3,
    Max = 4,
}
